import React, { FC } from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { LearnerInfo, USER_ROLES } from '../../../../types';
import { B2BLearnerSubscription } from '../../components/B2BLearnerSubscription';
import { B2CLearnerSubscription } from '../../components/B2CLearnerSubscription';
import { CardTitle } from '../../components/CardTitle';
import { ManagerSubscription } from '../../components/ManagerSubsription';
import NoSubscriptionView from '../../components/NoSubscriptionView';
import { OwnerSubscription } from '../../components/OwnerSubscription';

interface MySubscriptionPageProps {
  userInfo?: LearnerInfo;
  chargeBeeSite?: string;
  tenantTitle?: string | null;
}

const MySubscriptionPage: FC<MySubscriptionPageProps> = ({
  userInfo,
  chargeBeeSite,
  tenantTitle,
}) => {
  const { t } = useTranslation();
  const hasSubscription = userInfo?.has_subscription;
  const ownedSubscription = userInfo?.owned_subscription;
  const role = userInfo?.role;

  return (
    <>
      <Helmet>
        <title>
          {t('page.account.mySubscription')} - {tenantTitle}
        </title>
      </Helmet>
      <CardTitle title={t('page.account.mySubscription')} />
      {hasSubscription ? (
        <>
          {role === USER_ROLES.CompanyOwner && (
            <OwnerSubscription
              companyName={userInfo?.company?.name}
              chargeBeeSite={chargeBeeSite}
            />
          )}
          {role === USER_ROLES.TeamManager && (
            <ManagerSubscription companyName={userInfo?.company?.name} />
          )}
          {role === USER_ROLES.B2BLearner && (
            <B2BLearnerSubscription companyName={userInfo?.company?.name} />
          )}
          {role === USER_ROLES.B2CLearner && (
            <B2CLearnerSubscription chargeBeeSite={chargeBeeSite} />
          )}
        </>
      ) : (
        <NoSubscriptionView
          role={role}
          ownedSubscription={ownedSubscription}
          chargeBeeSite={chargeBeeSite}
          userId={userInfo?.id}
        />
      )}
    </>
  );
};

export default MySubscriptionPage;
